var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "a-card",
        { attrs: { title: _vm.$t("lbl_company") } },
        [
          _c(
            "a-row",
            { attrs: { gutter: [16, 16] } },
            [
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c("a-input-search", {
                    attrs: {
                      "allow-clear": "",
                      loading: _vm.loading.find,
                      "enter-button": ""
                    },
                    on: { search: _vm.searchData },
                    model: {
                      value: _vm.inputSearch,
                      callback: function($$v) {
                        _vm.inputSearch = $$v
                      },
                      expression: "inputSearch"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 16, align: "end" } },
                [
                  _vm.$can("create", "company")
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.modal.toggle()
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("lbl_create_new")) + " ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c("a-table", {
            attrs: {
              "data-source": _vm.dataCompany.data,
              columns: _vm.columns,
              "row-key": "id",
              size: "small",
              pagination: {
                showTotal: function() {
                  return _vm.$t("lbl_total_items", {
                    total: _vm.dataCompany.totalElements
                  })
                },
                total: _vm.dataCompany.totalElements,
                showSizeChanger: true,
                pageSizeOptions: _vm.PAGE_SIZE_OPTIONS,
                current: _vm.pagination.page
              },
              loading: _vm.loading.find,
              scroll: { x: 1000 }
            },
            on: { change: _vm.onChangeTable },
            scopedSlots: _vm._u(
              [
                {
                  key: "nullable",
                  fn: function(text) {
                    return _c("span", {}, [
                      _vm._v(" " + _vm._s(text || "-") + " ")
                    ])
                  }
                },
                _vm.$can("update", "company")
                  ? {
                      key: "edit",
                      fn: function(text, row) {
                        return [
                          _c(
                            "a-button",
                            {
                              attrs: { icon: "edit", type: "link" },
                              on: {
                                click: function($event) {
                                  return _vm.handleEdit(row)
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("lbl_edit")) + " ")]
                          )
                        ]
                      }
                    }
                  : null
              ],
              null,
              true
            )
          })
        ],
        1
      ),
      _c("ModalsForm", {
        attrs: { visible: _vm.modal.visible, company: _vm.modal.data },
        on: { close: _vm.handleFormClose, success: _vm.handleSuccess }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }